import React, { useState,useContext } from 'react';
import {useParams } from "react-router-dom";
import { toast } from "react-toastify";
//functions
import {
  getSystemSettings,
  // restaurantMenuLink,
} from "../../../../../functions/Functions";
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";

const DropdownButton = ({
  index,
  value,
  getLabel,
  isSelected,
  setSelected,
  selectedSubItem,
  setSelectedSubItem,
  options,
  getSubItemLabel,
}) => {
  const [open, setOpen] = useState(false);
  const { order_id } = useParams();
  const { generalSettings } =
  useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  
  return (
    <div key={index} className='mr-1 d-inline-block pos-menu-row btn-group mb-1'>
      <button
        disabled={authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1}
        className={`dropdwn--btn btn bg2-success text-white ${isSelected ? 'selected': ''}`}
        // disabled={order_id}
        onClick={() => {
          if(order_id && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))){
            toast.error("Can't change menu on edit complete the current order");
            return
          }
          setSelected(value); 
          const party =  options && options.find(item => item.name?.toLowerCase() === getLabel(value)?.toLowerCase());
         
          if(party === undefined || party === null){
            setOpen(true);
          }else{
            setOpen(false);
          }
          party && setSelectedSubItem(party, value)
          
        }}
      >
        {getLabel(value)}
      </button>
      <button
      className={`dropdwn1--btn btn bg2-success text-white ${isSelected ? 'selected': ''}`}
      disabled={authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1}
      onClick={() => {
        if(order_id && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))){
          toast.error("Can't change menu on edit complete the current order");
          setOpen(false);
          return
        }
        setOpen(!open)
        setSelected(value);
      
      }}
    >
    <i className="fa-sharp fa fa-caret-down lg-text" />
    </button>
      {open && isSelected && options && options.length ?
        <ul className='pos--dropdown-list '>
          {options.map((option, index) => (
            <li
              key={index}
              className={isSelected && selectedSubItem === option ? 'selected' : ''}
              onClick={() => {
                if(order_id && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))){
                  toast.error("Can't change menu on edit complete the current order");
                  setOpen(false);
                  return
                }
                setSelectedSubItem(option, value)
                setOpen(false)
              }}
            >{getSubItemLabel(option)}</li>
          ))}
        </ul>
        : null
      }
    </div>
  )
}

export default DropdownButton